import { makeActionFactory } from './actionFactory';
import { ReportId, ReportMap, Report } from 'types';
import { FormValues as NewReportFormValues } from 'ui/pages/reports/NewReportDialog';

export type ActionType =
    'REPORTS_LOAD_REQUEST'
    | 'REPORTS_LOAD_SUCCESS'
    | 'REPORTS_LOAD_FAILURE'
    | 'RUN_REPORT'
    | 'EDIT_REPORT'
    | 'DELETE_REPORT_REQUEST'
    | 'DELETE_REPORT_SUCCESS'
    | 'DELETE_REPORT_FAILURE'
    | 'REPORT_ADDED_UPDATED'
    ;

const actionFactory = makeActionFactory<ActionType>();


//
//  REPORTS_LOAD_REQUEST action notifies the app that we're trying to load reports
//
export interface ReportsLoadRequestAction {
    type: 'REPORTS_LOAD_REQUEST';
}
export const reportsLoadRequest = actionFactory.empty<ReportsLoadRequestAction>('REPORTS_LOAD_REQUEST');


//
//  REPORTS_LOAD_SUCCESS action notifies the app that we successfully loaded reports
//
export interface ReportsLoadSuccessAction {
    type: 'REPORTS_LOAD_SUCCESS';
    payload: ReportMap;
}
export const reportsLoadSuccess = actionFactory.payload<ReportsLoadSuccessAction, ReportMap>('REPORTS_LOAD_SUCCESS');


//
//  REPORTS_LOAD_FAILURE action notifies the app that we failed to load reports
//
export interface ReportsLoadFailureAction {
    type: 'REPORTS_LOAD_FAILURE';
    payload: Error;
    error: true;
}
export const reportsLoadFailure = actionFactory.error<ReportsLoadFailureAction>('REPORTS_LOAD_FAILURE');


//
//  RUN_REPORT action tells the app to generate a report
//
export interface RunReportAction {
    type: 'RUN_REPORT';
    payload: ReportId;
}
export const runReport = actionFactory.payload<RunReportAction, ReportId>('RUN_REPORT');


//
//  EDIT_REPORT action tells the app to edit an existing report
//
export interface EditReportAction {
    type: 'EDIT_REPORT';
    payload: ReportId | null;
    meta: {
        copy: boolean;
        values?: NewReportFormValues;
    };
}
export const editReport = actionFactory.payloadMeta<EditReportAction, ReportId | null, { copy: boolean; values?: NewReportFormValues }>('EDIT_REPORT');


//
//  DELETE_REPORT_REQUEST action tells the app to delete a report
//
export interface DeleteReportRequestAction {
    type: 'DELETE_REPORT_REQUEST';
    payload: ReportId;
}
export const deleteReportRequest = actionFactory.payload<DeleteReportRequestAction, ReportId>('DELETE_REPORT_REQUEST');


//
//  DELETE_REPORT_SUCCESS action notifies the app that a report was deleted successfully
//
export interface DeleteReportSuccessAction {
    type: 'DELETE_REPORT_SUCCESS';
    meta: {
        reportId: ReportId;
    };
}
export const deleteReportSuccess = actionFactory.meta<DeleteReportSuccessAction, { reportId: ReportId }>('DELETE_REPORT_SUCCESS');


//
//  DELETE_REPORT_FAILURE action notifies the app that a report failed to be deleted
//
export interface DeleteReportFailureAction {
    type: 'DELETE_REPORT_FAILURE';
    payload: Error;
    error: boolean;
    meta: {
        reportId: ReportId;
    };
}
export const deleteReportFailure = actionFactory.errorMeta<DeleteReportFailureAction, { reportId: ReportId }>('DELETE_REPORT_FAILURE');


//
//  REPORT_ADDED_UPDATED action notifies the app that a new report has been added
//
export interface ReportAddedUpdatedAction {
    type: 'REPORT_ADDED_UPDATED';
    payload: Report;
}
export const reportAddedUpdated = actionFactory.payload<ReportAddedUpdatedAction, Report>('REPORT_ADDED_UPDATED');



// WEBPACK FOOTER //
// ./src/actions/reportActions.ts